import PrimerPaymentMethodTypeAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/paymentMethodType.mdx";
import SdkUninitializedExceptionAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/sdkUninitializedException.mdx";
import UnsupportedPaymentMethodExceptionAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/unsupportedPaymentMethodException.mdx";
import ComponentValidationStatusAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentValidationStatus.mdx";
import BanksComponentUpdateCollectedDataAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/banksComponentUpdateCollectedData.mdx";
import BanksComponentStepAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/banksComponentStep.mdx";
import ComponentErrorAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentError.mdx";
import ComponentStartAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentStart.mdx";
import ComponentSubmitAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentSubmit.mdx";
import * as React from 'react';
export default {
  PrimerPaymentMethodTypeAndroid,
  SdkUninitializedExceptionAndroid,
  UnsupportedPaymentMethodExceptionAndroid,
  ComponentValidationStatusAndroid,
  BanksComponentUpdateCollectedDataAndroid,
  BanksComponentStepAndroid,
  ComponentErrorAndroid,
  ComponentStartAndroid,
  ComponentSubmitAndroid,
  React
};